import $ from '../$';
import data from '../functions/data';
$.data = data;
